<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>OUR ALUMNI OUR PRIDE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Alumni</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <h2 class="text-center">Videos</h2>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/1Kj8dJvFA81eimeE-fspj2iq2a0zj-jnx/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/1pUSZT9KOBWhRglr98QTI41I6y9odBbT5/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/1zZfO1YGSTgM2rF_g0kycwa6j6hPuFNzo/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/13nVVGgr-b0hP_eIHUWDwkG8PawGjDxQ4/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/1SoUsUy-cMa7hsc48mkHQQ6ILaBKccMJZ/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/1agY2n8pzBQHo0ONLNJesKWJ_lw_k5VCY/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <iframe class="cover-background w-100" style="height: 300px"
                        src="https://drive.google.com/file/d/1o9AHP3hFlwNMNqSnipDkNQSMXlCbbL1m/preview"
                        allow="autoplay"></iframe>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
               <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni1.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni2.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni3.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni4.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni5.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni6.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni7.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni8.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni9.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni10.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni11.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni12.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni13.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni14.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/Alumni15.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA2.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA3.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA4.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA5.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA6.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA7.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA8.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA9.jpg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA10.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA11.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA12.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA15.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA16.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA17.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA18.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA19.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA20.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA21.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA22.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA23.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA24.jpeg" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA25.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA26.jpeg" />
            </div>


            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA27.jpeg" />
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                <img class="cover-background w-100 h-100" src="assets/img/hostel/AlumniA28.jpeg" />
            </div>
        </div>
    </div>
</section>
